<template>
  <div class="challenge">
    <h2>
      Résultats <v-chip label class="gradient text-secondary">{{ challenge_name }}</v-chip>
    </h2>

    <FiltersClassement @onChangeFilters="onChangeFilters" :hide_challenge="true"></FiltersClassement>
    <TableauClassementChallenge v-if="challenge" :challenge="challenge" :filters="filters"></TableauClassementChallenge>
  </div>
</template>

<script>
import FiltersClassement from "@/components/Classements/FiltersClassements.vue";
import TableauClassementChallenge from "@/components/Classements/TableauClassementChallenge.vue";
export default {
  name: "ChallengeView",
  components: {
    FiltersClassement,
    TableauClassementChallenge,
  },
  data() {
    return {
      challenge_uuid: "",
      filters: {
        challenge: "Tous",
        sexe: "Tous",
        search: "",
      },
    };
  },
  watch: {
    "$route.params.challenge_uuid": {
      handler: function (challenge_uuid) {
        this.challenge_uuid = challenge_uuid;
        this.$store.dispatch("fetchChallenge", { challenge_uuid: this.challenge_uuid });
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    challenge_name() {
      console.log(this.challenge_uuid);
      switch (this.challenge_uuid) {
        case "12_heures":
          return "Challenge 12 heures";
        case "24_heures":
          return "Challenge 24 heures";
        default:
          return this.challenge_uuid;
      }
    },
    challenge() {
      return this.$store.getters.getChallengeByUuid(this.challenge_uuid);
    },
  },
  methods: {
    onChangeFilters(filters) {
      this.filters = filters;
    },
  },
  mounted() {
    this.challenge_uuid = this.$route.params.challenge_uuid;
  },
};
</script>

<style lang="scss" scoped></style>